<template>
    <div>
        <b-modal :active="true"
                 width="1200"
                 :canCancel="true">
            <div class="modal-card"
                 style="width: auto">
                <header class="modal-card-head">
                    <p class="modal-card-title">Projektnoter</p>
                </header>

                <section class="modal-card-body">
                    <div v-if="isLoading"
                         class="has-text-centered">
                        <br>
                        <loader />
                        Indlæser projektnoter
                    </div>

                    <template v-else>

                        <template v-if="!isEditing">
                            <template v-for="line in splitNotes">
                                {{ line }} <br />
                            </template>
                        </template>
                        <template v-else>
                            <b-field :label="$t('global.forms.Notes')">
                                <b-input type="textarea"
                                         cols="50"
                                         rows="10"
                                         v-model="content"
                                         name="notes"
                                         :data-vv-as="$t('global.forms.notes')" />
                            </b-field>

                        </template>

                    </template>
                </section>

                <footer class="modal-card-foot content-pulled-right">
                    <template v-if="!isEditing">
                        <button class="button is-danger"
                                @click="editProjectNotes"
                                type="button">{{ $t('global.actions.edit') }}</button>

                        <button class="button"
                                @click="$emit('close')"
                                type="button">{{ $t('global.actions.back') }}</button>
                    </template>
                    <template v-else>
                        <button class="button is-warning"
                                @click="updateProjectNotes"
                                type="button">{{ $t('global.actions.update') }}</button>
                        <button class="button is-danger"
                                @click="$emit('close')"
                                type="button">{{ $t('global.actions.back') }}</button>

                    </template>
                </footer>
            </div>
        </b-modal>
    </div>
</template>

<script>
import ProjectService from '@/taskflex/projects/services/ProjectService'

export default {
    name: 'ProjectNotesModal',
    props: [
        'project'
    ],
    data() {
        return {
            isEditing: false,
            content: null,
            projectNotes: null
        }
    },
    computed: {
        splitNotes() {
            if (!this.project.notes) return [];
            return this.project.notes.split('\n');
        },
    },
    methods: {
        async updateProjectNotesRecord() {
            this.isSubmitting = true;

            const options = {
                notes: this.content
            }

            ProjectService.updateNotes(this.project.id, options, ({ data }) => {
                this.isSubmitting = false;
                this.showModal = false;
            })
        },
        editProjectNotes() {
            this.isEditing = true;
            this.content = this.project.notes;
        },
        updateProjectNotes() {
            this.isEditing = false;

            // Send project notes to server
            this.updateProjectNotesRecord()
                .then(() => {
                    this.$emit('closeAndUpdate', this.content);
                });
        },
    }
}
</script>


// WEBPACK FOOTER //
// src/taskflex/administration/components/projects/ProjectNotesModal.vue